import { render, staticRenderFns } from "./MainLedgerCreateVAT.vue?vue&type=template&id=a9d659e4"
import script from "./MainLedgerCreateVAT.vue?vue&type=script&lang=js"
export * from "./MainLedgerCreateVAT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports